import Signup from './Signup';
import Login from './Login';
import Home from './Home';
import Game from './Game';
import CreatePlaylist from './CreatePlaylist';
import EditPlaylist from './EditPlaylist';
import Search from './Search';

export default {
  Signup,
  Login,
  Home,
  Game,
  CreatePlaylist,
  EditPlaylist,
  Search
};